import React, { Component } from "react";
import { connect } from "react-redux";
import { reformatDate, reformatTime } from "../../util/commonFunctions";
import { withRouter, Redirect } from "react-router-dom";



class webinarConfirmationPage extends Component {

  copyEventUrl(eventurl) {
    var clipBoardElem = document.createElement("input");
    document.body.appendChild(clipBoardElem);
    clipBoardElem.value = eventurl;
    clipBoardElem.select();
    document.execCommand('copy');
    document.getElementById('copyLinkBtn').textContent = "Link copied !";
  }

  goToPreviousPath = () => {
    this.props.history.goBack()
  }

  render() {
    if (this.props.eventDetails == null) {
      return (
        <Redirect to='/' />
      );
    }
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="head_section">
                <button className="back_buton" onClick={this.goToPreviousPath} >← Back to Event page</button>
                <a href="#"><img src="/assets/ausbiz_logo.png" alt="Ausbiz Logo" /></a>
              </div>
              <h3 className="heading_text">👏 Your seat is saved</h3>
              <span className="heading_sub_text">We’ve sent you an email with the details and calendar invite.</span>
              <div className="detail_section">
                <div className="detail_heading">Details</div>
                <span className="detail_text">{this.props?.eventDetails?.title}</span>
                <div className="date_time">
                  <span className="event_date">
                    <img src="/assets/svg/calendar.svg" alt="calendar" />
                    {reformatDate(this.props?.eventDetails?.eventDate)}
                  </span>
                  <span className="event_date">
                    <img src="/assets/svg/clock.svg" alt="Clock" />
                    {reformatTime(this.props?.eventDetails?.startTime)}-{reformatTime(this.props?.eventDetails?.endTime)} AEDT
                  </span>
                </div>
              </div>
              <div className="link_heading">Copy this link</div>
              <span className="link_sub_text">Here is your unique URL to access the event.  We’ve sent you an email.</span>
              <a href={this.props?.location?.state.eventUrl} className="copy_link">{this.props?.location?.state.eventUrl}</a>
              <button className="copy_btn" id="copyLinkBtn" onClick={() => { this.copyEventUrl(this.props?.location?.state.eventUrl) }}>Copy Link</button>
            </div>
          </div>
          {/* DO NOT REMOVE THIS BEAMER CODE */}
          <a
            id="callBeamer"
            data-beamer-keypress="true"
            style={{ visibility: "hidden", display: 'none' }}
          >
            What's New
          </a>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    eventDetails: state.eventDetails
  };
};

export default {
  component: connect(mapStateToProps)(withRouter(webinarConfirmationPage))
};
